module.exports = __webpack_public_path__ + "img/events-2.5bed8073.jpg";